/**
 * Language-Specific Font System
 * Detects language and applies appropriate font classes
 */

(function() {
  'use strict';
  
  // Language detection function
  function detectLanguage() {
    // Check URL for language indicators
    const path = window.location.pathname;
    const isEnglish = path.includes('/en');
    const isGeorgian = !isEnglish; // Default to Georgian if not English
    
    // Check HTML lang attribute
    const htmlLang = document.documentElement.lang;
    
    // Check for existing language classes
    const hasEnglishClass = document.body.classList.contains('english-language');
    const hasGeorgianClass = document.body.classList.contains('georgian-language');
    
    // Determine language
    let detectedLanguage = 'georgian'; // Default to Georgian
    
    if (isEnglish || htmlLang === 'en' || htmlLang === 'en-US' || htmlLang === 'en-GB' || hasEnglishClass) {
      detectedLanguage = 'english';
    } else if (htmlLang === 'ka' || htmlLang === 'ka-GE' || hasGeorgianClass) {
      detectedLanguage = 'georgian';
    }
    
    return detectedLanguage;
  }
  
  // Apply font classes based on detected language
  function applyFontClasses(language) {
    // Remove existing language classes
    document.body.classList.remove('english-language', 'georgian-language');
    document.documentElement.classList.remove('english-language', 'georgian-language');
    
    // Add appropriate language class
    if (language === 'english') {
      document.body.classList.add('english-language');
      document.documentElement.classList.add('english-language');
      console.log('Applied English fonts');
    } else {
      document.body.classList.add('georgian-language');
      document.documentElement.classList.add('georgian-language');
      console.log('Applied Georgian fonts');
    }
  }
  
  // Initialize font system
  function initFontSystem() {
    const language = detectLanguage();
    applyFontClasses(language);
    
    // Watch for URL changes (for SPA-like behavior)
    let currentPath = window.location.pathname;
    
    // Check for URL changes periodically
    setInterval(function() {
      if (window.location.pathname !== currentPath) {
        currentPath = window.location.pathname;
        const newLanguage = detectLanguage();
        applyFontClasses(newLanguage);
      }
    }, 1000);
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFontSystem);
  } else {
    initFontSystem();
  }
  
  // Also run on window load to ensure all resources are loaded
  window.addEventListener('load', function() {
    // Re-apply fonts after all resources are loaded
    const language = detectLanguage();
    applyFontClasses(language);
  });
  
  // Export for global access if needed
  window.FontLanguageSystem = {
    detectLanguage: detectLanguage,
    applyFontClasses: applyFontClasses,
    init: initFontSystem
  };
  
})();